import { makeAutoObservable } from 'mobx'
import UserProfileService from '../../../../shared/services/UserProfile.service'
import { UserFactory, CommissionLevelFactory, DivisionFactory } from '../../../../shared/factories'
import NotificationService from '../../../../shared/services/Notification.service'

async function searchCommissionLevels() {
  try {
    return await CommissionLevelFactory.findAll()
  } catch (ex) {
    return []
  }
}

const HIDDEN_COM_CODES = ['USABG1000', '00', 'RP100']

class ChangeRequestStore {
  enable = false
  userId = null
  isOpen = false
  isLoading = false
  isSubmitting = false
  ProfileUser = null
  RequestingUser = null
  Division = null
  CommLevelsList = null
  uplineName = ''
  commLevelName = ''
  requestNotes = ''

  constructor() {
    makeAutoObservable(this)
  }

  initUser = async userId => {
    if (userId && `${userId}` !== `${this.userId}`) {
      // To meet requirements, there must be impersonation currently.
      const enable =
        !!UserProfileService.isAssumed() &&
        UserProfileService.isA(['internal', 'management-group'], true) &&
        !UserProfileService.isA(['affiliate-group', 'associate-group'], true)
      if (!enable) return

      this.isLoading = true

      const Users =
          (
            await UserFactory.search({
              search: { id: [userId, UserProfileService.getUserId(true)] },
            })
          )?.models || [],
        Profile = Users.find(U => `${U.id()}` === `${userId}`),
        Requestor = Users.find(U => `${U.id()}` === `${UserProfileService.getUserId(true)}`)

      if (Profile && Requestor) {
        const [Division, CommLevelsList] = await Promise.all([
          DivisionFactory.findById(Requestor.get('u_devision')),
          searchCommissionLevels(),
        ])

        this.userId = userId
        this.ProfileUser = Profile
        this.RequestingUser = Requestor
        this.Division = Division
        this.CommLevelsList = (CommLevelsList || [])
          .filter(C => !HIDDEN_COM_CODES.includes(C.get('com_code')))
          .sort((a, b) => `${a.get('com_name')}`.localeCompare(b.get('com_name'), 'en'))
        this.isLoading = false
        this.enable = true
        return true
      }
    } else if (!userId) {
      this.isLoading = this.enable = false
      this.userId = this.ProfileUser = this.RequestingUser = this.Division = null
    }
  }

  isValid = () => {
    return !!this.uplineName || !!this.commLevelName
  }

  submit = async () => {
    if (this.isValid()) {
      this.isSubmitting = true

      const data = {
        change_agent: [
          this.ProfileUser?.get('u_nickname') || this.ProfileUser?.get('u_fname'),
          this.ProfileUser?.get('u_lname'),
        ]
          .join(' ')
          .trim(),
        change_agent_email: this.ProfileUser?.get('u_email'),
        requesting_agent: [
          this.RequestingUser?.get('u_nickname') || this.RequestingUser?.get('u_fname'),
          this.RequestingUser?.get('u_lname'),
        ]
          .join(' ')
          .trim(),
        requesting_email: this.RequestingUser?.get('u_email'),
        requesting_division: this.Division?.get('d_name'),
        requested_upline: this.uplineName || 'N/A',
        requested_comm_level: this.commLevelName || 'N/A',
        requested_notes: this.requestNotes,
      }

      await NotificationService.email({ email_id: 294, data })

      this.isSubmitting = false
      return true
    }

    throw new Error('Please enter a leader, select a commission level or both before submitting.')
  }
}

export default new ChangeRequestStore()
